module.exports = __webpack_public_path__ + "static/media/accountActive.44233fb8.svg";